<template>
  <v-card flat tile min-width="300px">
    <v-card-text>
      <audio
        id="audio-preview"
        :src="dataUrl"
        controls
        style="width: 100%; max-width: 450px"
      ></audio>
    </v-card-text>
  </v-card>
</template>

<script>
import { media } from '@/services/api'

export default {
  props: {
    value: { type: Object, default: null },
    height: { type: String, default: 'auto' },
    noCache: { type: Boolean, default: false },
    resolution: { type: String, default: 'original' }
  },
  data() {
    return {
      dataUrl: null,
      audio: null
    }
  },
  watch: {
    value(v) {
      this.audio = v
    }
  },
  mounted() {
    this.loadaudio(this.value)
  },
  methods: {
    async loadaudio(model) {
      try {
        this.fetching = true
        this.audio = model
        const response = await media.files.getDataUrl(model, 'original', {
          noCache: this.noCache
        })
        if (response) {
          this.dataUrl = response
        }
      } catch (err) {
        console.log('failed to load audio', err)
        this.error = err.message
      } finally {
        this.fetching = false
      }
    }
  },
  destroyed() {
    if (this.dataUrl) {
      URL.revokeObjectURL(this.dataUrl)
    }
  }
}
</script>

<style></style>
